export default {
    meta: {
      label: 'Polish'
    },
    data: {
      'pl-PL': {
        97: ['🚌', '🍉'],
        98: ['🍌', '🐏'],
        99: ['🍋', '🍪'],
        100: [['🦖', 'dinozaur'], ['🏠', 'dom']],
        101: [['🖥', 'ekran']],
        102: [['🏞', 'fotografia']],
        103: [['⭐️', 'gwiazda'], '🍐'],
        104: ['🍔'],
        105: ['🦃'],
        106: [['🍎', 'jabłko'], '🦔'],
        107: ['🐄', '☄️'],
        108: [['🍃', 'liście'], ['🛬', 'lądowanie']],
        109: ['🥕', '🐒'],
        110: [['🐻', 'niedźwiedź'], '⛺️'],
        111: ['✏️', '🐑'],
        112: ['🍅', ['⚽️', 'piłka']],
        114: ['🚲', ['🐛', 'robak']],
        115: ['🐘', ['🌞', 'słońce']],
        116: [['🎂', 'tort'], '👜'],
        117: [['🍗', 'udko'], '👄'],
        119: ['🐍', ['🚃', 'wagon']],
        122: [['🏰', 'zamek'], ['🍵', 'zupa']]
      }
    }
  };
  